import { render, staticRenderFns } from "./SOVall4page.vue?vue&type=template&id=538e916d&scoped=true"
import script from "./SOVall4page.vue?vue&type=script&lang=js"
export * from "./SOVall4page.vue?vue&type=script&lang=js"
import style0 from "./SOVall4page.vue?vue&type=style&index=0&id=538e916d&prod&scoped=true&lang=css"
import style1 from "./SOVall4page.vue?vue&type=style&index=1&id=538e916d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538e916d",
  null
  
)

export default component.exports